<template>
    <v-dialog v-model="d" width="30%" persistent>
        <v-card>
            <v-card-title>Delete Period</v-card-title>
            <v-card-text>
                Are you sure you want to delete {{active.name}}?
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="deletePeriod">Delete Period</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import {PeriodsHttp} from "../../http/PeriodsHttp";

    export default {
        name: "DeletePeriodModal",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            ...mapState("periods", ["deletePeriodDialog", "activePeriod"]),
            d: {
                get() {
                    return this.deletePeriodDialog;
                }
            },
            active: {
                get() {
                    return this.activePeriod;
                }
            }
        },
        methods: {
            ...mapActions("periods", ["setActivePeriod", "setManageDeletePeriodDialog", "setPeriods"]),
            ...mapMutations("app", ["setToast"]),
            async closeDialog() {
                await this.setActivePeriod({});
                await this.setManageDeletePeriodDialog(false);
            },
            async deletePeriod() {
                try {
                    this.isLoading = true;
                    await PeriodsHttp.archivePeriod(this.active._id);
                    this.setToast({color: 'success', text: 'Period deleted successfully', show: true});
                    await this.setPeriods();
                    await this.setActivePeriod({});
                    await this.setManageDeletePeriodDialog(false);
                } catch (err) {
                    this.setToast({color: 'error', text: err.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
